import * as React from 'react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../../theme';
import cn from 'classnames';
import { BaggageItem } from '../../../BaggageList';
import { Baggage } from '../../../../BaggageService/types';
import { Money } from '../../../../types';
import { SelectedUpgrade } from '../../types';
import { convertBaggageOnBaggageItem } from '../../../AdditionalBaggage/utils';
import { Segment } from '../../../types';
import { useBaggageSize } from '../../../../Baggage/Baggage/hooks';
import { BaggageSize } from '../../../../Baggage/Baggage/types';

interface Props {
	className?: string;
	upgradeServices: Baggage[][];
	upgradeMinPrice: Money | null;
	selectedServices: SelectedUpgrade[];
	segments: Segment[];
}

const Upgrade: React.FC<Props> = props => {
	const { IncludedBaggage: cssIncluded } = useTheme('IncludedBaggage');
	const { t } = useTranslation('IncludedBaggage');

	if (!props.upgradeServices[0]) {
		return null;
	}

	const upgradeItems = useMemo(() => {
		return props.upgradeServices.map(services => {
			return convertBaggageOnBaggageItem(services, props.selectedServices, props.segments);
		});
	}, [props.upgradeServices, props.selectedServices, props.segments]);

	return (
		<div className={cn(props.className)}>
			<div className={cssIncluded.header}>{t('Upgrade')}</div>
			<div className={cssIncluded.body}>
				{upgradeItems.map(item => {
					const size = useBaggageSize(item.baggage[0]);

					return <BaggageItem realIconSize={size !== BaggageSize.small} key={item.baggage[0].id} {...item} />;
				})}
			</div>
		</div>
	);
};

export default Upgrade;
